<template lang="html">
    <div v-if="params && params.isActive">
        <ModalDefault size="m" :with-content="true" @close="close();" :theme="true" :fix-height="false" :fix-width="false" :loading="loading">
            <template slot="main">
                <section class="delete-brand">
                    <p class="modal-title">{{ $trad.common.delete }}</p>
                    <p
                        v-html-safe="
                            $t('zonerole.deleteFromBrand', {
                                zone: params.zone.name.toUpperCase(),
                                brand: this.params.brandZone.brand.name.toUpperCase()
                            })
                        "
                    ></p>
                    <p>{{ $t("deleteBrand.messageAction") }}</p>
                    <div class="row d-flex justify-content-end">
                        <ClientColorButton :background-color="currentBrand.linksColor" @click="disableBrandZone();" class="mr-3">{{
                            $trad.common.delete
                        }}</ClientColorButton>
                        <ClientColorButton :inactiveColor="true" @click.prevent="close();">{{ $trad.common.cancel }}</ClientColorButton>
                    </div>
                </section>
            </template>
        </ModalDefault>
    </div>
</template>

<script lang="js">
import ModalDefault from "@/components/ui/ModalDefault";
import {mapState} from "vuex";
import historyService from "@/services/history";
import {OBJECT_TYPE, SHORT_DESCRIPTION} from "@/components/history/constants";
import httpService from "@/components/service";

export default {
    name: 'disable-brand-zone',
    components: {ModalDefault},
    props: [
        'params'
    ],
    data() {
        return {
            loading: false
        }
    },
    methods: {
        close() {
            this.params.isActive = false;
            this.$emit("close");
        },
        disableBrandZone () {
            this.isLoading = true;
            httpService.delete("/admin/brand-zones/" + this.params.brandZone.id)
                .then(() => {
                    this.dialogSuccess(SHORT_DESCRIPTION.BRAND_ZONE_DELETED + this.currentBrand.name.toUpperCase() + " brand");
                    this.isLoading = false;
                    this.params.isActive = false;
                    this.$emit("success");
                    this.close();
                })
                .catch(() => {
                    this.isLoading = false;
                    this.dialogError('ERROR');
                });
        }
    },
    computed: {
        ...mapState("currentUser", ["currentBrand"]),
    }
}
</script>

<style scoped lang="scss"></style>



// WEBPACK FOOTER //
// DisableBrandZone.vue?29ee9609